import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { registerSW } from "virtual:pwa-register";
import "./index.css";
import App from "./App.jsx";
import { CmsAuthProvider } from "./context/CmsAuthContext.jsx";
import { CookieConsentProvider } from "./context/CookieConsentContext.jsx";

registerSW({ immediate: true });

createRoot(document.getElementById("root")).render(
  <StrictMode>
    <HelmetProvider>
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <CookieConsentProvider>
          <CmsAuthProvider>
            <App />
          </CmsAuthProvider>
        </CookieConsentProvider>
      </BrowserRouter>
    </HelmetProvider>
  </StrictMode>
);
